package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "bg", default = false)
val BgStrings = Strings(
    analyzer = "Анализатор",
    appreciationOverview = "Преглед на оскъпяването",
    chartLegendInterest = "Лихва",
    chartLegendPrincipal = "Главница",
    chartXaxisMonths = "Месеци",
    chartYaxisPayment = "Вноска",
    code = "bg",
    costOfCredit = "Цена на кредита",
    creditDealAnalyzerDescription = "Въведете данните за вашия кредит, за да получите цялостен анализ на офертата. Нашият анализатор оценява ключови показатели, за да ви помогне да разберете реалната цена на кредита и да вземете информирано решение.",
    detailsGoodRateLongTerm = "Добра лихва, но дълъг срок води до висока обща цена.",
    detailsHighApr = "Висок ГПР. ",
    detailsHighInterestCost = "Висока обща цена на лихвата.",
    detailsHighRateShortTerm = "Висока лихва, но кратък срок поддържа общата цена ниска.",
    detailsLowApr = "Нисък ГПР. ",
    detailsLowInterestCost = "Ниска обща цена на лихвата.",
    discountsTradeIn = "Отстъпки / Trade-in",
    displayName = "Български",
    distribution = "Разпределение",
    downPayment = "Първоначална вноска",
    effectiveApr = "ГПР",
    headerBalance = "Остатък",
    headerDate = "Дата",
    headerInterest = "Лихва",
    headerMonth = "#",
    headerPayment = "Вноска",
    headerPrincipal = "Главница",
    hideDetails = "Скрий детайлите",
    interest = "Лихва",
    invalidData = "Невалидни данни",
    loanAmountSupportingText = "Пълният размер на кредита, включително всички допълнителни разходи.",

    loanDetails = "Детайли по кредита",
    paymentSupportingText = "Вашата прогнозна месечна вноска.",
    paymentComposition = "Структура на вноската",
    percentSymbol = "%",
    principal = "Главница",
    ratingBad = "Много лоша сделка",
    ratingExcellent = "Отлична сделка",
    ratingFair = "Приемлива сделка",
    ratingGood = "Добра сделка",
    ratingPoor = "Лоша сделка",
    schedule = "График",
    showDetails = "Покажи детайлите",
    summaryBad = "Много неизгодно, избягвайте ако е възможно.",
    summaryExcellent = "Отлични финансови условия.",
    summaryFair = "Приемливи условия, обмислете предоговаряне.",
    summaryGood = "Добри условия, стандартни за пазара.",
    summaryPoor = "Лоши условия, висока цена или лихва.",
    totalPaid = "Общо платено",
    lockTaxRate = "Заключи данъчна ставка",
    unlockTaxRate = "Отключи данъчна ставка",
    currencySymbol = "€",

    currency = "Валута",

    // Секция 1
    totalCreditAmount = "Размер на кредита (обща сума)",
    taxAmount = "Сума на данъка/удръжката",
    netAmountDisbursed = "Сума за усвояване",
    years = "Години",
    loanTermTotalMonths = "Срок на кредита (месеци)",

    // Секция 2
    monthlyInstallment = "Месечна вноска",
    principalInstallment = "Основна вноска (главница)",
    otherFees = "Други такси",

    // Секция 3
    insuranceCost = "Застраховка",
    aprc = "Годишен процент на разходите (ГПР)",
    totalAmountPayable = "Обща сума за връщане",
    prepaidFeeFixed = "Такса обработка (фиксирана сума)",

    // Допълнителни
    prepaidFeePercentage = "Такса обработка (процент)",
    months = "Месеци",
    description = "Този анализатор ви помага да прецените дали условията по кредита са изгодни за вас. За разлика от обикновените калкулатори, тук не се изисква въвеждане на лихвен процент. Приложението изчислява ГПР и общата цена на кредита въз основа на вноските и таксите, като предоставя оценка на сделката и детайлни графики.",
    agree = "Съгласен съм",
    information = "Информация",

    errorDivisionByZero = "Деление на нула",
    errorNegativeResult = "Отрицателен резултат",
    errorRateTooHigh = "Лихвеният процент е твърде висок",
    errorCalculation = "Моля, въведете коректни данни",
    errorCalculationOverflow = "ГПР е твърде висок, препълване при изчисление.",
    errorTotalPaymentIsLessThanLoanAmount = "Общо платената сума е по-малка от сумата на кредита.",

    close = "Затвори",
    hi = "Здравей",
    guest = "Гост",
    account = "Акаунт",
    signInWithGoogle = "Вход с Google",
    signOut = "Изход",
    settings = "Настройки",
    about = "Относно",
    privacyPolicy = "Политика за поверителност",
    termsOfService = "Условия за ползване",

    language = "Език",
    theme = "Тема",
    light = "Светла",
    dark = "Тъмна",
    system = "Системна",
    toggleExpand = "Разгърни/Свий",
)
